<template>
  <div class="env-switcher">
    <el-dropdown @command="handleEnvSwitch" trigger="click">
      <!-- <div class="env-button">
        <el-icon><Connection /></el-icon>
        <span class="env-text">{{ currentEnvName }}</span>
        <el-icon class="arrow"><ArrowDown /></el-icon>
      </div> -->
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item 
            v-for="env in envList" 
            :key="env.key"
            :command="env.key"
            :class="{ 'is-active': env.key === currentEnv }"
          >
            <div class="env-item">
              <el-icon v-if="env.key === currentEnv" class="check-icon">
                <Select />
              </el-icon>
              <div class="env-info">
                <div class="env-name">{{ env.name }}</div>
                <div class="env-url">{{ env.baseURL }}</div>
              </div>
            </div>
          </el-dropdown-item>
          <el-dropdown-item divided disabled>
            <div style="font-size: 12px; color: #909399;">
              切换后将自动刷新页面
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>

    <!-- 环境标识徽章 -->
    <el-tag 
      :type="getEnvTagType()" 
      size="small" 
      effect="dark"
      style="margin-left: 8px;"
    >
      {{ getEnvLabel() }}
    </el-tag>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { Connection, ArrowDown, Select } from '@element-plus/icons-vue'
import { getCurrentEnv, getAllEnvs, switchEnv, getEnvName } from '@/config/env'

// 当前环境
const currentEnv = ref('')
const currentEnvName = ref('')

// 所有可用环境
const envList = ref([])

// 初始化
onMounted(() => {
  currentEnv.value = getCurrentEnv()
  currentEnvName.value = getEnvName()
  envList.value = getAllEnvs()
})

// 切换环境
const handleEnvSwitch = (env) => {
  if (env === currentEnv.value) {
    ElMessage.info('已经是当前环境')
    return
  }

  const targetEnv = envList.value.find(e => e.key === env)
  
  ElMessageBox.confirm(
    `确定要切换到 ${targetEnv.name} 吗？页面将自动刷新。`,
    '切换环境',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(() => {
    // 切换环境（会自动刷新页面）
    switchEnv(env)
  }).catch(() => {
    ElMessage.info('已取消切换')
  })
}

// 获取环境标签类型
const getEnvTagType = () => {
  switch (currentEnv.value) {
    case 'local':
      return 'success'
    case 'test':
      return 'warning'
    case 'production':
      return 'danger'
    default:
      return 'info'
  }
}

// 获取环境标签文本
const getEnvLabel = () => {
  switch (currentEnv.value) {
    case 'local':
      return 'DEV'
    case 'test':
      return 'TEST'
    case 'production':
      return 'PROD'
    default:
      return 'UNKNOWN'
  }
}
</script>

<style lang="scss" scoped>
.env-switcher {
  display: flex;
  align-items: center;
  margin-right: 20px;

  .env-button {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.3s;
    user-select: none;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    .env-text {
      margin: 0 8px;
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }

    .arrow {
      font-size: 12px;
      color: #909399;
    }
  }

  .env-item {
    display: flex;
    align-items: center;
    padding: 4px 0;

    .check-icon {
      color: #67c23a;
      margin-right: 8px;
      font-size: 16px;
    }

    .env-info {
      flex: 1;

      .env-name {
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        margin-bottom: 2px;
      }

      .env-url {
        font-size: 12px;
        color: #909399;
      }
    }
  }

  :deep(.el-dropdown-menu__item) {
    &.is-active {
      background-color: #ecf5ff;
    }
  }
}
</style>

